<template>
	<div class="userListItemWrap">
		<div class="userListItem" :class="{ linkActive: hasLink }">
			<div class="photo">
				<component
						:is="hasLink ? 'router-link' : 'div'"
						class="photoLink"
						:to="hasLink ? '/account/user/' + id : null"
				>

					<template v-if="$inWindow(DATE.HALLOWEEN)">
						<img v-if="image && isErrorFile" :src="image" :alt="name" @error="onError">
						<svg-sprite v-else width="120" height="120" icon-id="pumpkin-halloween" halloween></svg-sprite>
					</template>
					<template v-else>
						<img v-if="image && isErrorFile" :src="image" :alt="name" @error="onError">
						<svg-sprite v-else icon-id="user"></svg-sprite>
					</template>
				</component>

				<div :class="[ 'radioStatus', { 'active': status }]"></div>
				<div class="photoZoom" @click="onPhotoZoom">
					<svg-sprite icon-id="icon-zoom-in" width="20" height="20"></svg-sprite>
				</div>
			</div>

			<item-info-row
					v-if="name"
					icon-id="icon-user"
					:is-item-text="false"
					:is-item-dashed="false"
					is-big-value
					is-flex-start
					:value="name"
			></item-info-row>

			<div class="itemRow Locatoin" v-if="location">
				<tool-tip
						margin="0"
						text="Location"
						content-class="top"
						:position="{ top: 'top' }"
				>
					<item-info-row
							icon-id="mapPin"
							:is-item-text="false"
							:is-item-dashed="false"
							is-flex-start
							:value="location"
					></item-info-row>
				</tool-tip>
			</div>

			<div class="itemRow Office" v-if="office">
				<tool-tip
						margin="0"
						text="Office"
						content-class="top"
						:position="{ top: 'top' }"
				>
					<item-info-row
							icon-id="department"
							:is-item-text="false"
							:is-item-dashed="false"
							is-flex-start
							:value="office"
					></item-info-row>
				</tool-tip>
			</div>

			<div class="itemRow Position" v-if="position">
				<tool-tip
						margin="0"
						text="Position"
						content-class="top"
						:position="{ top: 'top' }"
				>
					<item-info-row
							icon-id="directory"
							:is-item-text="false"
							:is-item-dashed="false"
							is-flex-start
							:value="position"
					></item-info-row>
				</tool-tip>
			</div>

			<div class="itemRow company" v-if="company">
				<tool-tip
						margin="0"
						text="Company"
						content-class="top"
						:position="{ top: 'top' }"
				>
					<item-info-row
							:icon-id="getIconId"
							icon-color="inherit"
							:is-item-text="false"
							:is-item-dashed="false"
							is-flex-start
							:value="company"
					></item-info-row>
				</tool-tip>
			</div>

			<div class="rowWrap Email">
				<item-info-row
						icon-id="icon-Email"
						text="Email"
						:value="email"
						:isItemText="false"
				></item-info-row>
			</div>
			<div class="rowWrap RingCentral"
			     v-for="(item, index) in contacts"
			     :key="uniqKey(index)"
			>
				<item-info-row
						icon-id="Phone"
						:text="item.name"
						:value="item.value"
				></item-info-row>
			</div>
		</div>
	</div>
</template>
<script>
import ItemInfoRow from "@/shared/ItemInfoRow/ItemInfoRow.vue";
import { mapActions } from "vuex";
import getUniqId from "@/helper/getUniqId";
import { getAppUrl } from "@/services";
import ToolTip from "@/shared/ToolTip/ToolTip.vue";
import IconBtn from "@/pages/Account/IconBtn/iconBtn.vue";
import { DATE } from "@/constants/date";

export default {
	name: "UserListItem",
	components: { IconBtn, ToolTip, ItemInfoRow },
	computed: {
		getIconId() {
			if (this.company === 'Altex') return 'icon-altex';
			if (this.company === 'FleetCare') return 'icon-fleet';
			return 'icon-company';
		},
	},
	props: {
		item: Object,
		hasLink: {
			type: Boolean,
			default: true,
		},
	},
	data: () => ({
		DATE,
		company: null,
		department: null,
		id: 80,
		image: null,
		location: null,
		name: null,
		office: null,
		position: null,
		status: true,
		isErrorFile: true,
		contacts: null,
		email: null,
	}),
	methods: {
		...mapActions([
			"setAlert",
		]),

		onError() {
			this.isErrorFile = false;
		},
		onPhotoZoom() {
			const photo = this.image;
			this.$emit('updatePhotoZoom', { photo });
		},
		uniqKey(id) {
			return getUniqId() + id;
		},
		parseString(str) {
			this.contacts = str.split(", ").map(item => {
				const [ name, value ] = item.split(": ").map(s => s.trim());
				return { name, value };
			});
		}
	},

	mounted() {
		const {
			company,
			department,
			id,
			image,
			location,
			name,
			office,
			position,
			status,
			contacts,
			email,

		} = this.item;
		this.company = company;
		this.department = department;
		this.id = id;
		this.image = getAppUrl + image;
		this.location = location;
		this.name = name;
		this.office = office;
		this.location = location;
		this.position = position;
		this.status = status;
		this.email = email;
		if (contacts) {
			this.parseString(contacts); // Преобразование строки в массив объектов
		}
	},
};
</script>
<style scoped lang="scss">
@import "userListItem";
</style>
